
 export function _requestJson(url, fetchOptions) {
   return new Promise((resolve, reject) => {
     fetch(url, fetchOptions)
       .then(response => response.json())
       .then((data) => {
         if ('error' in data) reject(new Error('Endpoint doesnt exist'))
         resolve(data)
       })
       .catch(error => reject(error))
   })
 }

export function _requestText(url, fetchOptions) {
   return new Promise((resolve, reject) => {
     fetch(url, fetchOptions)
       .then(response => response.text())
       .then((data) => {
         resolve(data)
       })
       .catch(error => reject(error))
   })
 }

 export function _postJson(url, data, postOptions) {
   return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'put',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(data),
      ...postOptions
    }).then(response => response.text())
      .then((data) => {
         resolve(data)
       })
       .catch(error => reject(error))
   })
 }